import { render, staticRenderFns } from "./MainProfile.vue?vue&type=template&id=b56308a2"
import script from "./MainProfile.vue?vue&type=script&lang=js"
export * from "./MainProfile.vue?vue&type=script&lang=js"
import style0 from "./MainProfile.vue?vue&type=style&index=0&id=b56308a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports